module.exports = __webpack_public_path__ + "img/西田优大.307313b0.png";